'use client';
import React, { useState } from 'react';
import { Filter, SlidersHorizontal } from 'lucide-react';

const markets = [
  { id: 'mkt-all', label: 'All Markets' },
  { id: 'mkt-indian', label: 'Indian' },
  { id: 'mkt-us', label: 'US Stocks' },
  { id: 'mkt-forex', label: 'Forex' },
  { id: 'mkt-crypto', label: 'Crypto' },
];

const types = [
  { id: 'type-all', label: 'All Types' },
  { id: 'type-intraday', label: 'Intraday' },
  { id: 'type-swing', label: 'Swing' },
  { id: 'type-longterm', label: 'Long-term' },
];

const risks = [
  { id: 'risk-all', label: 'All Risk' },
  { id: 'risk-low', label: 'Low' },
  { id: 'risk-medium', label: 'Medium' },
  { id: 'risk-high', label: 'High' },
];

const setups = [
  { id: 'setup-all', label: 'All Setups' },
  { id: 'setup-breakout', label: 'Breakout' },
  { id: 'setup-reversal', label: 'Reversal' },
  { id: 'setup-momentum', label: 'Momentum' },
];

export default function TradeFilterBar() {
  const [activeMarket, setActiveMarket] = useState('mkt-all');
  const [activeType, setActiveType] = useState('type-all');
  const [activeRisk, setActiveRisk] = useState('risk-all');
  const [activeSetup, setActiveSetup] = useState('setup-all');

  const chipClass = (active: boolean) =>
    `px-3 py-1.5 text-xs rounded-lg font-medium transition-all duration-150 cursor-pointer flex-shrink-0 ${
      active
        ? 'text-primary-foreground'
        : 'text-muted-foreground hover:bg-muted hover:text-foreground'
    }`;

  return (
    <div
      className="rounded-xl p-4 mb-5"
      style={{ background: 'var(--surface-2)', border: '1px solid var(--border)' }}
    >
      <div className="flex items-center gap-2 mb-3">
        <SlidersHorizontal size={14} style={{ color: 'var(--muted-foreground)' }} />
        <span className="text-xs font-medium" style={{ color: 'var(--muted-foreground)' }}>
          Filter Trade Ideas
        </span>
      </div>

      <div className="flex flex-wrap gap-y-3 gap-x-6">
        <div className="flex items-center gap-1 flex-wrap">
          <span className="text-xs mr-1" style={{ color: 'var(--muted-foreground)' }}>Market:</span>
          {markets.map((m) => (
            <button
              key={m.id}
              onClick={() => setActiveMarket(m.id)}
              className={chipClass(activeMarket === m.id)}
              style={activeMarket === m.id ? { background: 'var(--primary)' } : {}}
            >
              {m.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-1 flex-wrap">
          <span className="text-xs mr-1" style={{ color: 'var(--muted-foreground)' }}>Type:</span>
          {types.map((t) => (
            <button
              key={t.id}
              onClick={() => setActiveType(t.id)}
              className={chipClass(activeType === t.id)}
              style={activeType === t.id ? { background: 'var(--primary)' } : {}}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-1 flex-wrap">
          <span className="text-xs mr-1" style={{ color: 'var(--muted-foreground)' }}>Risk:</span>
          {risks.map((r) => (
            <button
              key={r.id}
              onClick={() => setActiveRisk(r.id)}
              className={chipClass(activeRisk === r.id)}
              style={activeRisk === r.id ? { background: 'var(--primary)' } : {}}
            >
              {r.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-1 flex-wrap">
          <span className="text-xs mr-1" style={{ color: 'var(--muted-foreground)' }}>Setup:</span>
          {setups.map((s) => (
            <button
              key={s.id}
              onClick={() => setActiveSetup(s.id)}
              className={chipClass(activeSetup === s.id)}
              style={activeSetup === s.id ? { background: 'var(--primary)' } : {}}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}